const stacks = [
  { label: '50', value: '50bb' },
  { label: '100', value: '100bb' },
];

// 200bb is hidden for both variants; PLO5 HU supports only 100bb.
export const getPostflopStackOptions = (isPlo5, tableSize) => stacks.filter((option) => (
  !isPlo5 || tableSize !== 'HU' || option.value === '100bb'
));

export const getSupportedPostflopStack = (stack, isPlo5, tableSize) => {
  const options = getPostflopStackOptions(isPlo5, tableSize);
  return options.find((option) => option.value === stack)
    || options.find((option) => option.value === '100bb');
};
